module.exports = __webpack_public_path__ + "img/banner22.d663bce0.png";